import { render, staticRenderFns } from "./success_tj.vue?vue&type=template&id=0893f0ca&scoped=true&"
import script from "./success_tj.vue?vue&type=script&lang=js&"
export * from "./success_tj.vue?vue&type=script&lang=js&"
import style0 from "./success_tj.vue?vue&type=style&index=0&id=0893f0ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893f0ca",
  null
  
)

export default component.exports